import { userConstants } from "../../constant";

const initialState = {
  loading: true,
  category: null,
  breadcrumbs: [],
  subcategories: [],
  products: [],
  product_count: 0,
};

export function categoryDetail(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_CATEGORY_DETAIL:
      if (!action.payload) {
        return { ...initialState, loading: false };
      }
      return {
        loading: false,
        category: action.payload.category,
        breadcrumbs: action.payload.breadcrumbs || [],
        subcategories: action.payload.subcategories || [],
        products: action.payload.products || [],
        product_count: action.payload.product_count || 0,
      };

    default:
      return state;
  }
}
